import { IRoad } from '../../types/geo';
import { DEFAULT_ROAD_DISTANCE, SavedFiltersIds } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { isArrayWithItems } from '../../utils';
import { setRoadFilter } from '../filters/actions';
import { removeSavedFilter } from '../saved_filters/removeSavedFilter';
import { onChangeRoadDistance } from './actions';

export function selectRoads(
  roads: IRoad[],
  save: boolean = true,
  distance: number = DEFAULT_ROAD_DISTANCE,
): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      savedFilters: { items },
    } = getState();
    const roadsSavedFilter = items.find(({ id }) => id === SavedFiltersIds.RoadDistance);
    if (roadsSavedFilter) {
      dispatch(removeSavedFilter(roadsSavedFilter));
    }
    if (isArrayWithItems(roads)) {
      dispatch(setRoadFilter(roads.map(({ id }) => id)));
      dispatch(onChangeRoadDistance(distance, save));
    }
  };
}
